import { IAPIData } from "../interfaces/Interfaces";

const Cards = ({
  data,
  modal,
  setModal,
  setDrink,
  setLoadingRecipe,
}: IAPIData) => {
  return (
    <div className="flex flex-wrap justify-center items-center lg:p-3 xl:p-3 2xl:p-3">
      {data.map((el) => (
        <div
          className="relative flex flex-col justify-start w-60 items-center bg-black border-black border-1 rounded-md m-10 text-center shadow-black shadow-2xl animate-fadeIn"
          key={el.strDrink}
        >
          <h1 className="text-xl font-bold p-3 text-white">{el.strDrink}</h1>
          <img
            className="w-full"
            src={`${el.strDrinkThumb}/preview`}
            alt={el.strDrink}
          />
          <span
            className="text-white text-lg hover:text-highlight p-3 font-semibold"
            onClick={() => {
              setDrink(el);
              setModal(!modal);
              setTimeout(() => {
                setLoadingRecipe(false);
              }, 1500);
            }}
          >
            Recipe & Directions
          </span>
        </div>
      ))}
    </div>
  );
};

export { Cards };
